import { useQuery } from '@tanstack/react-query'
import { ConfigSetting } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { setConfigSetting } from 'stores/setting.store'

export const CONFIG_SETTING_QUERY_KEY = ['setting', 'config']

const fetchConfigSetting = async (): Promise<ConfigSetting | null> => {
  const res = await AppAdmin.getConfigSetting()
  if (res?.data?.success) {
    const data = (res.data.data || {}) as ConfigSetting
    setConfigSetting(data)
    return data
  }
  return null
}

export const useConfigSetting = () => {
  const query = useQuery({
    queryKey: CONFIG_SETTING_QUERY_KEY,
    queryFn: fetchConfigSetting,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  })

  return {
    configSetting: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  }
}

export default useConfigSetting
